// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"284":"6f560e53","701":"3de717c8"}[chunkId] + ".css";
};